import { render, staticRenderFns } from "./khach-hang-nhan.vue?vue&type=template&id=32bd46ec&"
import script from "./khach-hang-nhan.vue?vue&type=script&lang=js&"
export * from "./khach-hang-nhan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports